module.exports = __webpack_public_path__ + "media/images/logo-white-105743fb8eb442930454e8c597904476.png";